const copyText = async (value) => {
    await window.navigator.clipboard.writeText(value);
};

export { copyText };
//# sourceMappingURL=index.js.map
